import { ProductMessage, Message } from '../../../PdpProductProvider/types';
import { parseProductMessage } from './parseProductMessage';

export const PRODUCT_MESSAGE_TYPES = {
  SERVICES: 'Services',
  SPECIAL_OFFERS: 'SpecialOffers',
  INSTALLATION: 'Installation',
  IMPORTANT: 'Important',
};

export const getProductMessages = (
  messages?: Array<Message>,
  isHideAwaitingStock?: boolean,
  isAwaitingStock?: boolean,
  isPreOrder?: boolean
): Array<ProductMessage> => {
  const filteredMessages: Array<Message> = [];
  messages?.forEach(message => {
    if (message.type === PRODUCT_MESSAGE_TYPES.SERVICES || message.type === PRODUCT_MESSAGE_TYPES.SPECIAL_OFFERS)
      return null;

    if (message.subType === PRODUCT_MESSAGE_TYPES.IMPORTANT && isHideAwaitingStock) {
      if (!isAwaitingStock && !isPreOrder) {
        filteredMessages.unshift(message);
      }
      return;
    }

    filteredMessages.push(message);
  });
  return filteredMessages.map(message => parseProductMessage(message)).filter(m => !!m.content);
};
